<div class="modal" (click)="onClose()">
  <div class="modal__content  {{ work!.layoutClass }}" (click)="$event.stopPropagation()">
    <button class="modal__close" (click)="onClose()">✖</button>

    <div class="modal__body">
        @for (image of work!.images; track $index) {
          <picture class="work__img">
            <source [srcset]="work!.images[$index]" type="image/webp" class="work__img">
            <img [src]="image" alt="{{ work?.title }} image" class="work__img">
          </picture>
        }
      <div class="modal__text">
        <h4 class="modal__title">{{ work!.title }}</h4>
        <div class="modal__description" [innerHTML]="work!.description"></div>
      </div>
    </div>
  </div>
</div>
